import PropTypes from 'prop-types';
import React from 'react';
import FlexRow from '../../../common/components/layout/FlexRow';
import DownloadReceipt from './DownloadReceipt';
import ReceiptUserDetails from './ReceiptUserDetails';

const RowActionReceiptUser = ({receipt}) => {
  return (
    <FlexRow>
      <DownloadReceipt receipt={receipt}/>
      <ReceiptUserDetails receipt={receipt}/>
    </FlexRow>
  );
};

RowActionReceiptUser.propTypes = {
  receipt: PropTypes.object.isRequired,
};

export default (RowActionReceiptUser);
